function getCookieValue(cookieString, cookieName) {
  // @ts-ignore
  return ('; ' + cookieString).split(`; ${cookieName}=`).pop().split(';')[0];
}

export { getCookieValue };
